import createService from 'API/Service/createService';

function useCreateService(
    currentCompany,
    setIsCreatingService,
    setHasCreateServiceError,
    onServiceCreate,
) {
    function createNewService({ serviceProfile, serviceType, serviceName }) {
        const { authPolicy } = serviceProfile;
        if (authPolicy === 0 && serviceType !== 'OperatorPlatform') {
            setHasCreateServiceError(
                `The Service Profile for ${serviceType} does not allow Auth.`,
            );
            return;
        }

        // Only set isCreatingService after validation passes
        setIsCreatingService(true);
        createService({
            companyId: currentCompany,
            serviceType,
            name: serviceName,
        })
            .then((response) => {
                if (response?.response?.data?.message) {
                    setHasCreateServiceError(response.response.data.message);
                } else {
                    onServiceCreate(response.data);
                }
            })
            .catch((e) => setHasCreateServiceError(e?.response?.data?.message));
    }

    return { createNewService };
}

export { useCreateService };
